module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-home"
  }, [_c('div', {
    staticClass: "hero-home__hero"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.scrolled
      }),
      expression: "{ active: true, callback: scrolled }"
    }],
    staticClass: "hero-home__waypoint"
  }), _c('div', {
    staticClass: "hero-home__overlay"
  }), _c('div', {
    staticClass: "hero-home__container"
  }, [_c('Icon', {
    staticClass: "hero-home__logo",
    class: {
      'hero-home__logo--active': !_vm.$store.state.loading
    },
    attrs: {
      "name": "WhiteLogoVert"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7d6b48","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-home/hero-home.pug
// module id = 559
// module chunks = 1